import { Stack } from '@mui/material';
import React from 'react';
import { FinsightEntityField } from 'shared';

import { CheckboxWithLabel } from './CheckboxWithLabel';
import { InputArea } from './InputArea';

interface UIVisibilitySettingsProps {
  field: FinsightEntityField['schema'];
  setField: (field: FinsightEntityField['schema']) => void;
}

export function UIVisibilitySettings({
  field,
  setField,
}: UIVisibilitySettingsProps) {
  return (
    <InputArea
      name="UI Visibility"
      description="Where this field should be displayed"
    >
      <Stack direction="row" gap={1} flexWrap="wrap">
        <CheckboxWithLabel
          label="Card"
          checked={field.ui?.visibility?.card ?? false}
          setChecked={(v) =>
            setField({
              ...field,
              ui: {
                ...field.ui,
                visibility: { ...field.ui?.visibility, card: v },
              },
            })
          }
        />
        <CheckboxWithLabel
          label="List"
          checked={field.ui?.visibility?.list ?? false}
          setChecked={(v) =>
            setField({
              ...field,
              ui: {
                ...field.ui,
                visibility: { ...field.ui?.visibility, list: v },
              },
            })
          }
        />
        <CheckboxWithLabel
          label="Entity Main"
          checked={field.ui?.visibility?.entity_main ?? false}
          setChecked={(v) =>
            setField({
              ...field,
              ui: {
                ...field.ui,
                visibility: {
                  ...field.ui?.visibility,
                  entity_main: v,
                },
              },
            })
          }
        />
        <CheckboxWithLabel
          label="Entity Sidebar"
          checked={field.ui?.visibility?.entity_sidebar ?? false}
          setChecked={(v) =>
            setField({
              ...field,
              ui: {
                ...field.ui,
                visibility: {
                  ...field.ui?.visibility,
                  entity_sidebar: v,
                },
              },
            })
          }
        />
      </Stack>
    </InputArea>
  );
}
